const isKeyboardClickEvent = (/** @type {KeyboardEvent} */ e) => e.key === ' ' || e.key === 'Enter';
const isSpaceKeyboardClickEvent = (/** @type {KeyboardEvent} */ e) => e.key === ' ';

const proxyClickEvent = new CustomEvent("proxyclick", {
	detail: {},
	bubbles: true,
	cancelable: true,
	composed: true,
});

export class UiEventController {


	constructor(host) {
		(this.host = host).addController(this);
		this.active = false;
	}
	hostConnected() {
		this.host.addEventListener('keydown', this.__keydownHandler);
		this.host.addEventListener('keyup', this.__keyupHandler);
		this.host.addEventListener('mousedown', this.__mousedownHandler);
		this.host.addEventListener('proxyclick', this.__proxyClick.bind(this));
	}
	hostDisconnected() {
		this.host.removeEventListener('keydown', this.__keydownHandler);
		this.host.removeEventListener('keyup', this.__keyupHandler);
		this.host.removeEventListener('mousedown', this.__mousedownHandler);
		this.host.removeEventListener('proxyclick', this.__proxyClick.bind(this));
	}

	/**
	 * @param {KeyboardEvent} event
	 * @private
	 */
	__keydownHandler(event) {
		if (this.active || !isKeyboardClickEvent(event)) {
			if (isSpaceKeyboardClickEvent(event)) {
				event.preventDefault();
			}
			return;
		}

		if (isSpaceKeyboardClickEvent(event)) {
			event.preventDefault();
		}

		this.active = true;
		/**
		 * @param {KeyboardEvent} keyupEvent
		 */
		const keyupHandler = (keyupEvent) => {
			if (isKeyboardClickEvent(keyupEvent)) {
				this.active = false;
				document.removeEventListener('keyup', keyupHandler, true);
			}
		};
		document.addEventListener('keyup', keyupHandler, true);
	}

	/**
	 * @param {KeyboardEvent} event
	 * @private
	 */
	__keyupHandler(event) {
		if (isKeyboardClickEvent(event)) {
			// Fixes IE11 double submit/click. Enter keypress somehow triggers the __keyUpHandler on the native <button>
			if (event.target && event.target !== this) {
				return;
			}
			// dispatch click
			event.target.dispatchEvent(proxyClickEvent);
		}
	}

	/**
	 * @private
	 */
	__mousedownHandler(event) {
		this.active = true;
		const mouseupHandler = () => {
			this.active = false;
			document.removeEventListener('mouseup', mouseupHandler);
			event.target.removeEventListener('mouseup', mouseupHandler);

		};
		document.addEventListener('mouseup', mouseupHandler);
		event.target.addEventListener('mouseup', mouseupHandler);
	}

	/**
	 * @returns {boolean}
	 * @private
	 */
	__proxyClick() {
		const anchor = this.host.shadowRoot.querySelector('a[class|=mds]');
		const checkRadio = this.host.shadowRoot.querySelector('[type=checkbox],[type=radio]');
		if (this.disabled) {
			return false;
		} else if (anchor) {
			anchor.click();
		} else if(checkRadio) {
			checkRadio.click();
			this.host.internals.setFormValue(this.host.value);
		} else if(this.host && this.host.internals && this.host.internals.form) {
			const form = this.host.internals.form;
			this.host.internals.setFormValue(this.host.value);
			if(this.host.type === 'submit' && form.checkValidity()) form.submit();
		}
	}
	/**
	 * @returns {boolean|boolean}
	 */
	isLink() {
		return /cta|news/i.test(this.context) || this.type === 'link';
	}

}
